export const PROFILE_FIELDS = `
  fragment profileFields on Profile {
    _id
    firstName
    lastName
    mobile
    email
    club
    teams
    yearOfBirth
    dateOfBirth
    gender
    medicalInfo {
      hasAllergiesOrConditions
      details
    }
    address {
      street
      city
      state
      postalCode
      country
    }
    height
    weight
    userId
    photo
    parents
    gdprConsent {
      accepted
      acceptedAt
      acceptedBy
      gdprUrl
    }
  }
`;

export const PROFILE_FIELDS_WITH_INVITATION_STATUS = `
  fragment profileFieldsWithInvitationStatus on ProfileWithInvitationStatus {
    _id
    firstName
    lastName
    mobile
    email
    club
    teams
    yearOfBirth
    dateOfBirth
    gender
    medicalInfo {
      hasAllergiesOrConditions
      details
    }
    address {
      street
      city
      state
      postalCode
      country
    }
    height
    weight
    favourites {
      teams
      players
      brands
    }
    userId
    photo
    parents
    invitationStatus
    gdprConsent {
      accepted
      acceptedAt
      acceptedBy
      gdprUrl
    }
  }
`;

export const GET_PROFILES = `
  ${PROFILE_FIELDS_WITH_INVITATION_STATUS}
  query GetClubProfiles($term: String, $clubId: String, $teamId: String, $skip: Int, $limit: Int, $sortingDir: String, $sortingField: String) {
    ClubProfiles(term: $term, clubId: $clubId, teamId: $teamId, skip: $skip, limit: $limit, sortingDir: $sortingDir, sortingField: $sortingField) {
      ...profileFieldsWithInvitationStatus
    }
  }
`;

export const GET_CLUB_PLAYER_DIRECTORY = `
  query GetClubPlayerDirectory(
    $clubId: String!
    $teamIds: [String]
    $ageGroups: [String]
    $statuses: [String]
    $documentStatuses: [String]
    $gdprStatuses: [String]
    $balanceStatuses: [String]
    $term: String
    $skip: Int
    $limit: Int
    $sortingDir: String
    $sortingField: String
  ) {
    clubPlayerDirectory(
      clubId: $clubId
      teamIds: $teamIds
      ageGroups: $ageGroups
      statuses: $statuses
      documentStatuses: $documentStatuses
      gdprStatuses: $gdprStatuses
      balanceStatuses: $balanceStatuses
      term: $term
      skip: $skip
      limit: $limit
      sortingDir: $sortingDir
      sortingField: $sortingField
    ) {
      items {
        _id
        firstName
        lastName
        photo
        dateOfBirth
        yearOfBirth
        teamIds
        guardians {
          _id
          firstName
          lastName
          photo
        }
        registrationStatus
        documentStatus
        gdprStatus
        missingDocumentCount
        balanceAmounts {
          currency
          amount
        }
      }
      total
      teamCount
      teams {
        _id
        name
        ageGroup
      }
    }
  }
`;

export const GET_TEAM_PLAYER_PARENTS = `
  query GetTeamPlayerParents($term: String, $clubId: String!, $teamId: String!, $skip: Int, $age: Int, $limit: Int, $sortingDir: String, $sortingField: String) {
    TeamPlayerParents(term: $term, clubId: $clubId, teamId: $teamId, skip: $skip, age: $age, limit: $limit, sortingDir: $sortingDir, sortingField: $sortingField) {
      _id
      firstName
      lastName
      photo
    }
  }
`;

export const COUNT_PROFILES = `
  query GetClubProfiles($term: String, $clubId: String!, $teamId: String, $skip: Int, $limit: Int) {
    ClubProfiles(term: $term, clubId: $clubId, teamId: $teamId, skip: $skip, limit: $limit) {
      _id
    }
  }
`;

export const GET_TEAMS_PROFILES_FOR_SQUAD_SELECTION = `
  query GetTeamsProfilesForSquadSelection($term: String, $clubId: String!, $teamId: String, $skip: Int, $limit: Int) {
    ClubProfiles(term: $term, clubId: $clubId, teamId: $teamId, skip: $skip, limit: $limit) {
        _id
        firstName
        lastName
        photo
    }
  }
`;

export const GET_TEAMS_PROFILES_IDS = `
   ${PROFILE_FIELDS_WITH_INVITATION_STATUS}
  query GetTeamsProfilesIds($term: String, $clubId: String!, $teamId: String, $skip: Int, $limit: Int) {
    ClubProfiles(term: $term, clubId: $clubId, teamId: $teamId, skip: $skip, limit: $limit) {
      _id
    }
  }
`;


export const CREATE_PROFILE = `
  mutation CreateClubProfile($firstName: String,
    $lastName: String,
    $mobile: String,
    $email: String,
    $club: String,
    $teams: [String],
    $yearOfBirth: String,
    $dateOfBirth: String,
    $gender: String,
    $medicalInfo: ProfileMedicalInfoInput,
    $ssn: String,
    $athleteId: ProfileAthleteIdInput,
    $medicalClearance: ProfileMedicalClearanceInput,
    $clothingSize: String,
    $address: ProfileAddressInput,
    $height: String,
    $weight: String,
    $photo: String) {
      createProfile(firstName: $firstName,
        lastName: $lastName,
        mobile: $mobile,
        email: $email,
        club: $club,
        teams: $teams,
        yearOfBirth: $yearOfBirth,
        dateOfBirth: $dateOfBirth,
        gender: $gender,
        medicalInfo: $medicalInfo,
        ssn: $ssn,
        athleteId: $athleteId,
        medicalClearance: $medicalClearance,
        clothingSize: $clothingSize,
        address: $address,
        height: $height,
        weight: $weight,
        photo: $photo) {
          _id
        }
  }
`;

export const UPDATE_PROFILE = `
  mutation UpdateProfile($profileId: String!,
    $firstName: String,
    $lastName: String,
    $mobile: String,
    $email: String,
    $club: String,
    $teams: [String],
    $yearOfBirth: String,
    $dateOfBirth: String,
    $gender: String,
    $medicalInfo: ProfileMedicalInfoInput,
    $ssn: String,
    $athleteId: ProfileAthleteIdInput,
    $medicalClearance: ProfileMedicalClearanceInput,
    $clothingSize: String,
    $address: ProfileAddressInput,
    $height: String,
    $weight: String,
    $gdprConsent: ProfileGdprConsentInput) {
      updateProfile(profileId: $profileId,
        firstName: $firstName,
        lastName: $lastName,
        mobile: $mobile,
        email: $email,
        club: $club,
        teams: $teams,
        yearOfBirth: $yearOfBirth,
        dateOfBirth: $dateOfBirth,
        gender: $gender,
        medicalInfo: $medicalInfo,
        ssn: $ssn,
        athleteId: $athleteId,
        medicalClearance: $medicalClearance,
        clothingSize: $clothingSize,
        address: $address,
        height: $height,
        weight: $weight,
        gdprConsent: $gdprConsent) {
          _id
        }
  }
`;

export const GET_PROFILE_BY_ID = `
  query ($ids: [String]!) {
    profilesById(ids: $ids) {
      _id
      firstName
      lastName
      mobile
      email
      club
      teams
      yearOfBirth
    dateOfBirth
    gender
    medicalInfo {
      hasAllergiesOrConditions
      details
    }
    address {
      street
      city
      state
      postalCode
      country
    }
      photo
      parents
      gdprConsent {
        accepted
        acceptedAt
        acceptedBy
        gdprUrl
      }
      userId
    }
  }
`;


export const GET_PROFILE_FOR_MANAGEMENT = `
  query ($ids: [String]!) {
    profilesById(ids: $ids) {
      _id
      firstName
      lastName
      mobile
      email
      club
      teams
      yearOfBirth
    dateOfBirth
    gender
    medicalInfo {
      hasAllergiesOrConditions
      details
    }
    ssn
    athleteId {
      id
      expirationDate
      fileUrl
    }
    medicalClearance {
      startDate
      expirationDate
      fileUrl
    }
    clothingSize
    address {
      street
      city
      state
      postalCode
      country
    }
      photo
      parents
      gdprConsent {
        accepted
        acceptedAt
        acceptedBy
        gdprUrl
      }
      userId
    }
  }
`;

export const GET_PROFILE_NOTE = `
query ($profileId: String, $clubId: String) {
  getProfileNote (profileId: $profileId, clubId: $clubId) {
    _id
    profileId
    clubId
    note
  }
}
`;

export const buildProfileIdentityPayload = (values, original = {}, formatDateOnly) => {
  const payload = {ssn: typeof values.ssn === "string" ? values.ssn.trim() || null : null};
  const athleteMetadata = {
    ...(values.athleteId?.id?.trim() ? {id: values.athleteId.id.trim()} : {}),
    ...(formatDateOnly(values.athleteId?.expirationDate) ? {expirationDate: values.athleteId.expirationDate} : {}),
  };
  if (Object.keys(athleteMetadata).length) payload.athleteId = athleteMetadata;
  else if (values.athleteIdExplicitlyCleared && !original.athleteId?.fileUrl) payload.athleteId = null;

  if (values.medicalClearanceEnabled) {
    payload.medicalClearance = {
      startDate: formatDateOnly(values.medicalClearance?.startDate),
      expirationDate: formatDateOnly(values.medicalClearance?.expirationDate),
    };
  } else if (values.medicalClearanceExplicitlyCleared && !original.medicalClearance?.fileUrl) {
    payload.medicalClearance = null;
  }
  return payload;
};

export const persistProfileMetadata = async ({persistedProfileId, create, update, payload}) => {
  if (persistedProfileId) {
    await update({...payload, profileId: persistedProfileId});
    return persistedProfileId;
  }
  return create(payload);
};

export const getProfileImagePlan = (currentImages = [], initialImages = []) => {
  const currentImage = currentImages?.[0];
  const initialImage = initialImages?.[0];
  const initialFileName = initialImage ? initialImage.split('/').pop() : null;
  const newFile = currentImage?.name ? currentImage : null;
  return {
    initialFileName,
    newFile,
    shouldDelete: !!initialImage && (!currentImage || (!!newFile && newFile.name !== initialFileName)),
  };
};

export const CREATE_PROFILE_NOTE = `
mutation ($profileId: String, $clubId: String, $text: String) {
  createProfileNote (profileId: $profileId, clubId: $clubId, text: $text) {
    _id
    profileId
    clubId
    note
  }
}
`;

export const UPDATE_PROFILE_NOTE = `
mutation ($noteId: String, $clubId: String, $text: String) {
  updateProfileNote (noteId: $noteId, clubId: $clubId, text: $text) {
    _id
    profileId
    clubId
    note
  }
}
`;

export const DELETE_PROFILE_NOTE = `
mutation ($noteId: String, $clubId: String) {
  deleteProfileNote (noteId: $noteId, clubId: $clubId)
}
`;

export const GET_PROFILE_ACCOUNT_ACTIVITY = `
  query ProfileAccountActivity($clubId: String!, $profileId: String!) {
    profileAccountActivity(clubId: $clubId, profileId: $profileId) {
      profileId
      player { _id lastSeen activityStatus }
      parents { _id firstName lastName photo lastSeen activityStatus }
    }
  }
`;
